"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventProbabilityOutcomeNameV2 = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const i18next_1 = __importDefault(require("i18next"));
const outcomeHasParamsV2 = (probabilityParamTypes, parameterTypes) => {
    return parameterTypes.every((parameterType) => probabilityParamTypes.has(parameterType));
};
const getScoreNameV2 = (paramsMap) => {
    if (getOutcomeParameterValueV2({
        paramsMap,
        parameterType: betweb_openapi_axios_1.ParameterType.HomeScore,
    }) === '-1' &&
        getOutcomeParameterValueV2({
            paramsMap,
            parameterType: betweb_openapi_axios_1.ParameterType.AwayScore,
        }) === '-1') {
        return i18next_1.default.t('anyOther');
    }
    return `${getOutcomeParameterValueV2({
        paramsMap,
        parameterType: betweb_openapi_axios_1.ParameterType.HomeScore,
    })}:${getOutcomeParameterValueV2({
        paramsMap,
        parameterType: betweb_openapi_axios_1.ParameterType.AwayScore,
    })}`;
};
const getOutcomeParameterValueV2 = ({ paramsMap, parameterType, }) => {
    return paramsMap[parameterType] || '';
};
const getOutcomeParameterPlayerV2 = ({ paramsMap, players, }) => {
    const playerId = paramsMap[betweb_openapi_axios_1.ParameterType.PlayerId];
    const player = players[playerId];
    return (player === null || player === void 0 ? void 0 : player.name) || '';
};
const getEventProbabilityOutcomeNameV2 = ({ eventProbability, name, transformParamValueFunc, players, }) => {
    var _a;
    const parameters = (_a = eventProbability === null || eventProbability === void 0 ? void 0 : eventProbability.parameters) !== null && _a !== void 0 ? _a : [];
    if (parameters.length === 0) {
        return name;
    }
    const paramsMap = parameters.reduce((acc, param) => {
        acc[param.type] = param.value;
        return acc;
    }, {});
    const paramsTypes = new Set(Object.keys(paramsMap));
    switch (true) {
        // Case Score
        case outcomeHasParamsV2(paramsTypes, [
            betweb_openapi_axios_1.ParameterType.HomeScore,
            betweb_openapi_axios_1.ParameterType.AwayScore,
        ]):
            return getScoreNameV2(paramsMap);
        // Case Value
        case outcomeHasParamsV2(paramsTypes, [betweb_openapi_axios_1.ParameterType.Value]):
            return `${name} ${transformParamValueFunc(getOutcomeParameterValueV2({
                paramsMap,
                parameterType: betweb_openapi_axios_1.ParameterType.Value,
            }))}`;
        // Case Goals
        case outcomeHasParamsV2(paramsTypes, [betweb_openapi_axios_1.ParameterType.GoalsRange]):
            return getOutcomeParameterValueV2({
                paramsMap,
                parameterType: betweb_openapi_axios_1.ParameterType.GoalsRange,
            });
        // Case Players
        case outcomeHasParamsV2(paramsTypes, [betweb_openapi_axios_1.ParameterType.PlayerId]):
            return getOutcomeParameterPlayerV2({
                paramsMap,
                players,
            });
        default: {
            return name;
        }
    }
};
exports.getEventProbabilityOutcomeNameV2 = getEventProbabilityOutcomeNameV2;
//# sourceMappingURL=getEventProbabilityOutcomeNameV2.js.map